<template>
  <hypto-popup :title="`Logout session?`">
    <template v-slot:body>
      <p>This will remove access to your Hypto Account from the device <b>{{sessionOptions.login_ip}} - {{sessionOptions.device_app}} on {{sessionOptions.device_os}}</b></p>
    </template>

    <template v-slot:footer>
      <button class="primary-btn" @click="logout">Logout</button>
    </template>
  </hypto-popup>
</template>

<script>
import HyptoPopup from '@/components/global/HyptoPopup'

import ApiServices from '@/services/api/userProfile'
import UserApis from '@/services/api/users'

export default {
  name: 'LogoutConfirmation',
  components: { HyptoPopup },
  props: {
    sessionOptions: Object,
    userId: Number
  },
  methods: {
    logout () {
      if (this.$route.name === 'UserProfileSettings') {
        this.destroySession()
      } else {
        this.destroyUserSession()
      }
    },
    destroySession () {
      ApiServices.destroySession({token: this.sessionOptions.token}).then(response => {
        this.successToastMsg(response.message)
        this.$emit('refreshUserSessions')
      }).catch((response) => {
        this.errorToastMsg(response.body.message)
      })
    },
    destroyUserSession () {
      UserApis.destroySession(this.userId, {token: this.sessionOptions.token}).then(response => {
        if (response.success) {
          this.successToastMsg(response.message)
          this.$emit('refreshUserSessions')
        } else {
          this.errorToastMsg(response.message)
        }
      }).catch((response) => {
        this.errorToastMsg(response.body.message)
      })
    }
  }
}
</script>

<style scoped lang="scss">
  .desktop {
    p {
      text-align: center;
    }
  }
</style>
